import { Typography } from '@mui/material';
import type { RestoreJob } from '@repo/api-gw-sdk';

import { QueryResultsField } from '@/app/(dashboard)/jobs/[tab]/queryResultsField';
import { PropertyType, type FilterProperty } from '@/types/advanceFilter';

export const queryResults: FilterProperty<RestoreJob> = {
  name: 'queryResults',
  displayName: 'Query results',
  type: PropertyType.String,
  group: 'restore-to',
  field: {
    Component: ({ entity }) => {
      return (
        entity.outputResources?.outputLocation && (
          <QueryResultsField entity={entity} />
        )
      );
    },
  },
};

export const snapshotId: FilterProperty<RestoreJob> = {
  name: 'output',
  displayName: '  ',
  type: PropertyType.String,
  group: 'restore-to',
  field: {
    Component: ({ entity }) => {
      return (
        entity.outputResources?.snapshotId && (
          <Typography>{entity.outputResources.snapshotId}</Typography>
        )
      );
    },
  },
};

export const instanceId: FilterProperty<RestoreJob> = {
  name: 'output',
  displayName: 'Instance',
  type: PropertyType.String,
  group: 'restore-to',
  field: {
    Component: ({ entity }) => {
      return (
        entity.outputResources?.instanceId && (
          <Typography>{entity.outputResources.instanceId}</Typography>
        )
      );
    },
  },
};

export const volumeId: FilterProperty<RestoreJob> = {
  name: 'output',
  displayName: 'Volume',
  type: PropertyType.String,
  group: 'restore-to',
  field: {
    Component: ({ entity }) => {
      return (
        entity.outputResources?.volumeId &&
        !entity.outputResources.instanceId && (
          <Typography>{entity.outputResources.volumeId}</Typography>
        )
      );
    },
  },
};

export const imageId: FilterProperty<RestoreJob> = {
  name: 'output',
  displayName: 'Image',
  type: PropertyType.String,
  group: 'restore-to',
  field: {
    Component: ({ entity }) => {
      return (
        entity.outputResources?.imageId && (
          <Typography>{entity.outputResources.imageId}</Typography>
        )
      );
    },
  },
};

// const restoredPersistentVolumes_example = [
//   {
//     newVolumeId: 'vol-0ae0f1d5cdc3b3705',
//     originalVolumeId: 'vol-00be120855f9c3781',
//     originalPvcName: 'ron-pvc-1',
//     originalPvName: 'pvc-2a979978-f4ac-41e8-bb2b-eed354291900',
//   },
//   {
//     newVolumeId: 'vol-0a6ce397f9560b670',
//     originalVolumeId: 'vol-036af2bffea584188',
//     originalPvcName: 'ron-pvc-3',
//     originalPvName: 'pvc-7b37f18d-5955-4987-b98b-5074647af366',
//   },
//   {
//     newVolumeId: 'vol-0c1a31758e8775c7b',
//     originalVolumeId: 'vol-05f222016ce336b07',
//     originalPvcName: 'ron-pvc',
//     originalPvName: 'pvc-d4b71706-8aae-4083-918d-af2d0242251a',
//   },
//   {
//     newVolumeId: 'vol-03686d970e301bde8',
//     originalVolumeId: 'vol-0978c2685f0d585c9',
//     originalPvcName: 'ron-pvc-2',
//     originalPvName: 'pvc-cf2d9b48-23fc-47a8-a27f-4e3ff9348466',
//   },
// ];

// export const restoredPersistentVolumes: FilterProperty<RestoreJob> = {
//   name: 'output',
//   displayName: 'Restored Persistent Volumes',
//   type: PropertyType.String,
//   group: 'restore-to',
//   field: {
//     Component: ({ entity }) => {
//       return (
//         entity.outputResources?.restoredPersistentVolumes && (
//           <Typography>
//             {entity.outputResources.restoredPersistentVolumes
//               .map((x: { originalPvcName: string }) => x.originalPvcName)
//               .filter((x: string) => !!x)
//               .join(', ')}
//           </Typography>
//         )
//       );
//     },
//   },
// };
